import React from "react";
import RecordedMetadata, {
  type RecordedCareMetadata,
} from "./RecordedMetadata";
import { RECORDED_METADATA_VIEW_FLAG } from "@/config/releaseFlags";
import { useFeatureFlags } from "@/utils/providers/feature-flags-provider";

// Additive presentation only: existing care metadata does not use this gate.
// Read the exact record's server fields; never substitute observation clocks,
// reviewer/viewer identity, source references or clinical versions.
export default function AdditionalRecordedMetadata({
  record,
}: {
  record?: RecordedCareMetadata | null;
}) {
  const flags = useFeatureFlags();
  if (
    !flags.initialized ||
    flags.loading ||
    !flags.isEnabled(RECORDED_METADATA_VIEW_FLAG, false)
  )
    return null;
  return <RecordedMetadata record={record} />;
}
